import React from 'react';
import Select from "react-select";

const BrandCategories = ({ from, state, setState, categories }) => {
    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };
    const groupBadgeStyles = {
        backgroundColor: 'var(--lightBlue)',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    };

    const formatGroupLabel = data => {
        return <div style={groupStyles}>
            <span>{data.label}</span>
            <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    }


    const obj = {}
    const root = []

    for (const item of categories) {
        if (item.parent) {
            typeof obj[item.parent.id] === "undefined" ?
                obj[item.parent.id] = { label: item.parent.name, options: [{ label: item.name, value: item.id }] } :
                obj[item.parent.id].options.push({ label: item.name, value: item.id })
        } else {
            root.push({ label: item.name, value: item.id })
        }
    }

    const getCategoryGroup = Object.values(obj)
    const defaultValue = from && from.parent ?
        { value: from.id, label: from.name } :
        getCategoryGroup.length ?
            getCategoryGroup[0].options[0] :
            root[0];
    const options = getCategoryGroup.length ? getCategoryGroup : root;

    return <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={defaultValue}
        // value={defaultValue}
        isLoading={state.loading}
        isRtl
        isSearchable
        name="color"
        formatGroupLabel={formatGroupLabel}
        options={options}
        onChange={({ value }) => setState({ ...state, cat: value, loading: true })}
    />
};

export default BrandCategories;
